module.exports = __webpack_public_path__ + "static/media/Team 18 - GreenTech.370224db.png";